function detailText(detail) {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (typeof detail?.message === "string") return detail.message;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || item?.message || "")
      .filter(Boolean)
      .join(" ");
  }
  return "";
}

export function getActionableError(error, fallback = "Something went wrong. Please try again.") {
  if (!error?.response) {
    return "Callsect could not reach the server. Check your connection and try again.";
  }

  const status = error.response.status;
  const detail = detailText(error.response.data?.detail);

  if (status === 401) return "Your session has expired. Sign in again to continue.";
  if (status === 403) return detail || "This action is not available for your account.";
  if (status === 404) return detail || "The requested item could not be found.";
  if (status === 413) return detail || "This file is larger than the current upload limit.";
  if (status === 415) {
    return detail || "Callsect could not read this audio. Use an MP3, WAV, AAC, or M4A file.";
  }
  if (status === 429) return detail || "Your current beta allowance has been reached.";
  if (status >= 500) {
    return detail || "Callsect is temporarily unavailable. Wait a moment and try again.";
  }

  return detail || fallback;
}
